import { Button } from "@evidenceb/athena-common/design-system/Button";
import React, { useContext } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import { configStore } from "../../../contexts/ConfigContext";
import useAssetsDetails from "../../../hooks/useAssetsDetails";
import { BASE_ROUTE as AUTH_ROUTE } from "../routes";
import { Image } from "@evidenceb/athena-common/modules/Assets";

import "./RedirectionQueryLogin.scss";

const RedirectionQueryLogin = () => {
    const intl = useIntl();
    const { config } = useContext(configStore);
    const assetsDetails = useAssetsDetails();

    return (
        <PageWrapper className="select-authentication-mode-page">
            <div className="select-authentication-mode">
                <Image
                    className="select-authentication-mode__logo"
                    assetsDetails={assetsDetails}
                    src={config.logos.header_client}
                />
                <div className="select-authentication-mode__main-container">
                    <div className="select-authentication-mode__introduction">
                        <h2 className="select-authentication-mode__welcome">
                            {intl.formatMessage(messages.introduction, {
                                app: config.client_name,
                            })}
                        </h2>
                    </div>
                    <div className="select-authentication-mode__options">
                        <Button
                            className="select-authentication-mode__external"
                            asRouterLink={{
                                onClick: () => window.location.assign("/"),
                                to: "/",
                            }}
                            label={intl.formatMessage(messages.GARConnexion)}
                        />
                        <p>{intl.formatMessage(messages.GarConnexionHowTo)}</p>
                        <div className="select-authentication-mode__semi-auto">
                            <Link to={AUTH_ROUTE}>
                                {intl.formatMessage(messages.semiAuthConnexion)}
                            </Link>
                        </div>
                    </div>
                    <div>
                        <Image
                            className="select-authentication-mode__mascot"
                            assetsDetails={assetsDetails}
                            src={config.logos.mascotIcon}
                        />
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
};

export default RedirectionQueryLogin;

const messages = defineMessages({
    GARConnexion: {
        id: "login-connectionGar",
        defaultMessage: "Je me connecte à l'application via le GAR",
    },
    GarConnexionHowTo: {
        id: "gar-connexion-how-to",
        defaultMessage:
            "Pour vous déconnecter du GAR, déconnectez-vous de votre ENT",
    },
    semiAuthConnexion: {
        id: "login-connectionSemiAuth",
        defaultMessage: "To log in with a mail and a password click here.",
    },
    introduction: {
        id: "login-welcome",
        defaultMessage: "Welcome on {app}.",
    },
});
